import { useCallback } from "react";
import axiosConfig from "../../axiosConfig";
import sanitizeDirectoryStructure from "../utils/sanitizeDirectoryStructure";

const useFileManagerApi = () => {
  const fetchFolderStructure = useCallback(async () => {
    const response = await axiosConfig.get("/file-manager/get-folder-structure");
    const { directoryStructure } = response.data || {};
    return sanitizeDirectoryStructure(directoryStructure || {});
  }, []);

  const getQuota = useCallback(async () => {
    return axiosConfig.get("/file-manager/quota");
  }, []);

  const requestDownloadLink = useCallback(async (filepath) => {
    return axiosConfig.get("/file-manager/download", {
      params: { filepath },
    });
  }, []);

  const downloadBinaryByEncodedPath = useCallback(async (encodedPath) => {
    return axiosConfig.get(`/file-manager/download/?filepath=${encodedPath}`, {
      responseType: "blob",
    });
  }, []);

  const deleteFiles = useCallback(async (files) => {
    return axiosConfig.delete("file-manager/delete", {
      data: { files },
    });
  }, []);

  const createFolder = useCallback(async (payload) => {
    return axiosConfig.post("file-manager/create-folder", payload);
  }, []);

  const getPresignedUploadUrl = useCallback(async (params) => {
    return axiosConfig.get("file-manager/get-presigned-url", { params });
  }, []);

  return {
    fetchFolderStructure,
    getQuota,
    requestDownloadLink,
    downloadBinaryByEncodedPath,
    deleteFiles,
    createFolder,
    getPresignedUploadUrl,
  };
};

export default useFileManagerApi;

